export default "__VITE_ASSET__Cmj1Dc7J__"